import { BagDto } from '@features/ManualSorting/model/manualSorting';
import { Column, DateCellComponent } from '@uni-space/uni-components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useShipmentScanningBagSettingsTable = () => {
  const { t } = useTranslation();

  const columns: Column<BagDto>[] = useMemo(
    () => [
      {
        header: t('tableHeader.number'),
        accessor: 'number',
        textAlign: 'center',
      },
      {
        header: t('tableHeader.parcelsCount'),
        accessor: 'parcelsCount',
        textAlign: 'center',
      },
      {
        header: t('tableHeader.actualWeightHeader'),
        accessor: 'actualWeight',
        textAlign: 'center',
        renderCell: (row) => `${row.actualWeight?.value} g`,
      },
      {
        header: t('bagCode'),
        accessor: 'bagCode',
        textAlign: 'center',
      },
      {
        header: t('tableHeader.regionZone'),
        accessor: 'regionZone',
        textAlign: 'center',
      },
      {
        header: t('tableHeader.closedAt'),
        accessor: 'closedAt',
        textAlign: 'center',
        renderCell: (row) => <DateCellComponent justify="center" date={row.closedAt} zone="local" />,
      },
    ],
    [t],
  );

  return { columns };
};
